/**
 * Data Tables
 */

export const EMAIL_VALIDATION_REGEX =
  /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/

export const HOME_FOR_ROLE_ROUTE_PREFIX = 'home-for-role-'

export const ROLES = {
  Educacion: { homeRoute: '' },
  Admin: { homeRoute: '' },
  Caja: { homeRoute: '' },
  Oraculo: {
    homeRoute: '',
    canSimulate: ['Educacion', 'Caja', 'Admin', 'Oraculo'],
  },
}

export const PROCEEDING_STATUS_MAP = {
  p: { label: 'Pendiente Autorización', colorClass: "text-error" },
  s: { label: 'Acreditación pendiente', colorClass: "text-error" },
  a: { label: 'Acreditado', colorClass: "text-success" },
}

export const STUDENT_STATUS_MAP = {
  i: 'Datos incompletos',
  c: 'Esperando documentación',
  w: 'Validación pendiente',
  a: 'Apto para acreditación',
  p: 'Acreditación Completada',
  r: 'Rechazado',
  s: 'Acreditación pendiente',
}

export const DATA_TABLE_OPTIONS = {
  rowPerPageOptions: [10, 20, 50, 100],
  rowPerPageDefault: 50,
  spaceBetweenRows: 3,
}

export const UNAUTHORIZED_401_API_MESSAGES = {
  not_authenticated: 'user_not_authenticated',
  role_not_found: 'role_not_found',
  user_not_found: 'user_not_found',
  not_autorized: 'not_authorice',
}

export const SCHOOL_CYCLE_OPTIONS = (options = {}) => {
  let { raw = null } = options
  let max = new Date().getFullYear() + 1
  let min = SCHOOL_CYCLE_STARTS_AT
  let years = []

  for (let i = max; i >= min; i--) {
    years.unshift(i)
  }
  let selectOptions = years.reverse()
  if (raw) {
    return years
  }
  return selectOptions.map((year) => {
    return { value: year, label: `Año ${year}` }
  })
}

export const CRYPTO_CURRENCY_SYMBOL = 'ASL'

export const SNACK_AUTOHIDE_TIMEOUT = 9000

export const SCHOOL_CYCLE_STARTS_AT = 2011

export const EMAIL_VALIDATION = {
  required: 'El email es requerido',
  pattern: {
    value:
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    message: 'El email no es válido',
  },
}

export const STUDENT_MODEL_FIELDS = {
  studentdni: {
    name: 'studentdni',
    label: 'DNI',
    type: 'number',
    group: 'Datos del alumno',
    readOnly: true,
  },
  gender: {
    name: 'gender',
    label: 'Sexo',
    type: 'select',
    validation: { required: 'El campo es requerido' },
    options: [
      { value: 'M', label: 'Masculino' },
      { value: 'F', label: 'Femenino' },
      { value: 'N', label: 'Neutro' },
    ],
    group: 'Datos del alumno',
  },
  firstname: {
    name: 'firstname',
    validation: { required: 'El nombre es requerido' },
    label: 'Nombre',
    type: 'text',
    group: 'Datos del alumno',
  },
  lastname: {
    label: 'Apellido',
    validation: { required: 'El apellido es requerido' },
    type: 'text',
    group: 'Datos del alumno',
  },
  birthday: {
    label: 'Fecha de nacimiento',
    validation: { required: 'Debe ingresar la fecha de nacimiento' },
    type: 'date',
    group: 'Datos del alumno',
  },
  email: {
    label: 'Email',
    validation: EMAIL_VALIDATION,
    type: 'email',
    group: 'Datos del alumno',
  },
  phone: {
    name: 'phone',
    label: 'Teléfono celular',
    validation: {
      minLength: { value: 7, message: 'El telefono debe contener 7 números' },
    },
    type: 'text',
    group: 'Datos del alumno',
  },
  schoolcycle: {
    name: 'schoolcycle',
    label: 'Ciclo escolar',
    validation: {
      pattern: {
        value: /^(20)\d{2}$/,
        message:
          'El ciclo escolar no es vealido, introducir el año completo (ej. 2022)',
      },
    },
    type: 'select',
    options: SCHOOL_CYCLE_OPTIONS(),
    group: 'Datos del establecimiento',
  },
  denomination: {
    label: 'Denominación',
    type: 'text',
    group: 'Datos del establecimiento',
  },
  cue: {
    label: 'CUE',
    type: 'text',
    group: 'Datos del establecimiento',
  },
  cueanexo: {
    label: 'CUE anexo',
    type: 'text',
    group: 'Datos del establecimiento',
  },
  career: {
    label: 'Carrera / Modalidad',
    type: 'text',
    group: 'Datos del establecimiento',
  },
  grade: {
    label: 'Año / Grado',
    type: 'text',
    group: 'Datos del establecimiento',
  },
  section: {
    label: 'Sección',
    type: 'text',
    group: 'Datos del establecimiento',
  },
  shift: {
    label: 'Turno',
    type: 'text',
    group: 'Datos del establecimiento',
  },
  tutorfirstname: {
    label: 'Nombre',
    type: 'text',
    group: 'Datos del tutor',
  },
  tutorlastname: {
    label: 'Apellido',
    type: 'text',
    group: 'Datos del tutor',
  },
  tutordni: {
    label: 'DNI número',
    type: 'text',
    group: 'Datos del tutor',
  },
  tutordnitype: {
    label: 'DNI tipo',
    type: 'text',
    group: 'Datos del tutor',
  },
  tutorcontact: {
    label: 'Teléfono / email',
    type: 'text',
    group: 'Datos del tutor',
  },
  city: {
    label: 'Ciudad',
    type: 'text',
    group: 'Datos del alumno',
  },
  zipcode: {
    label: 'Código postal',
    type: 'text',
    group: 'Datos del alumno',
  },
  universityname: {
    label: 'Nombre de la universidad',
    type: 'text',
    group: 'Datos de la universidad',
  },
  carrear: {
    label: 'Carrera',
    type: 'text',
    group: 'Datos de la universidad',
  },
}

export const BOUSER_MODEL_FIELDS = {
  firstname: {
    name: 'firstname',
    label: 'Nombre',
    type: 'text',
    group: 'Datos personales',
    validation: { required: 'El campo es requerido', maxLength: { value: 100, message: "No puede tener mas de 100 caracteres" } },
  },
  lastname: {
    name: 'lastname',
    label: 'Apellido',
    type: 'text',
    group: 'Datos personales',
    validation: { required: 'El campo es requerido', maxLength: { value: 100, message: "No puede tener mas de 100 caracteres" } },
  },
  email: {
    name: 'email',
    label: 'Email',
    validation: EMAIL_VALIDATION,
    type: 'email',
    group: 'Datos del alumno',
  },
  roleid: {
    name: 'roleid',
    type: 'rolesSelect',
    label: 'Rol',
    validation: { required: 'El campo es requerido', maxLength: { value: 100, message: "No puede tener mas de 100 caracteres" } },
    group: 'Datos del alumno',
  },
  phone: {
    name: 'phone',
    label: 'Teléfono celular',
    validation: {
      required: 'El campo es requerido',
      minLength: { value: 7, message: 'El teléfono debe contener 7 números' },
      maxLength: { value: 50, message: "No puede tener mas de 50 números" },
    },
    type: 'text',
  },
  twofa: {
    name: 'twofa',
    label: 'Verificación en dos pasos',
    validation: { required: 'El campo es requerido', maxLength: { value: 100, message: "No puede tener mas de 100 caracteres" } },
    type: 'select',
    options: [
      { value: '0', label: 'Email' },
      { value: '1', label: 'teléfono' }
    ],
  },
}

export const UNBALANCE_MODEL_FIELDS = {
  firstname: {
    name: 'firstname',
    label: 'Nombre',
    type: 'text'
  },
  lastname: {
    name: 'lastname',
    label: 'Apellido',
    type: 'text'
  },
  balancecatche: {
    name: 'balancecatche',
    label: 'Balance cacheado',
    type: 'text'
  },
  bcbalance: {
    name: 'bcbalance',
    label: 'Balance en BC',
    type: 'text'
  },
  wbalance: {
    name: 'wbalance',
    label: 'Balance de movimientos',
    type: 'text'
  },
  diff: {
    name: 'diff',
    label: 'Diferencia',
    type: 'number'
  },
  updatedat: {
    name: 'updatedat',
    label: 'Fecha de desbalance',
    type: 'date'
  },

}
export const USER_STUDENT_STATUS_MAP = {
  false: 'Deshabilitado',
  true: 'Habilitado',
}
